import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg, inr, fmtDate, today } from "@/lib/api";
import { PageHeader, StatCard, Field, TableWrap, Empty, th, td, tr } from "@/components/common";

const HEAD = ["LR", "Date", "Driver", "KM Run", "Salary", "Per-KM Allowance", "Diesel Debited", "Net", "Paid", "Recovered", "Balance", "Status"];

function bal(v) {
  return <span className={v > 0.5 ? "text-emerald-700" : v < -0.5 ? "text-rose-600" : ""}>{v > 0.5 ? "Pay " : v < -0.5 ? "Recover " : ""}{inr(Math.abs(v), 2)}</span>;
}

function VehicleBlock({ r }) {
  return (
    <div className="space-y-2" data-testid={`perkm-vehicle-${r.vehicle_id}`}>
      <div className="flex flex-wrap items-baseline gap-3"><h3 className="font-mono text-base font-bold">{r.vehicle_number}</h3>
        <span className="text-xs text-muted-foreground">₹{r.per_km_rate}/km · {r.trips.length} trips · {Number(r.km).toLocaleString("en-IN")} km</span></div>
      <TableWrap>
        <thead><tr>{HEAD.map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
        <tbody>
          {r.trips.map((t) => <tr key={t.id} className={tr} data-testid={`perkm-trip-${t.id}`}>
            <td className={td}><Link to={`/bookings/${t.id}`} className="font-mono text-xs text-primary">{t.lr_number}</Link></td><td className={`${td} whitespace-nowrap`}>{fmtDate(t.date)}</td>
            <td className={td}>{t.driver}</td><td className={td}>{Number(t.km).toLocaleString("en-IN")}</td><td className={`${td} amount`}>{inr(t.salary, 2)}</td>
            <td className={`${td} amount`}>{inr(t.allowance, 2)}</td><td className={`${td} amount text-rose-600`}>{inr(t.diesel, 2)}</td><td className={`${td} amount font-semibold`}>{inr(t.net, 2)}</td>
            <td className={`${td} amount`}>{inr(t.paid, 2)}</td><td className={`${td} amount`}>{inr(t.recovered, 2)}</td><td className={`${td} amount font-semibold`}>{t.settled ? "-" : bal(t.balance)}</td>
            <td className={`${td} text-xs`}>{t.settled ? "Settled" : t.status}</td></tr>)}
          <tr className="bg-secondary/50 font-bold"><td className={td} colSpan={3}>Total</td><td className={td}>{Number(r.km).toLocaleString("en-IN")}</td><td className={`${td} amount`}>{inr(r.salary, 2)}</td>
            <td className={`${td} amount`}>{inr(r.allowance, 2)}</td><td className={`${td} amount`}>{inr(r.diesel, 2)}</td><td className={`${td} amount`}>{inr(r.net, 2)}</td>
            <td className={`${td} amount`}>{inr(r.paid, 2)}</td><td className={`${td} amount`}>{inr(r.recovered, 2)}</td><td className={`${td} amount`} data-testid={`perkm-balance-${r.vehicle_id}`}>{bal(r.balance)}</td><td className={td} /></tr>
        </tbody>
      </TableWrap>
    </div>
  );
}

export default function PerKmReport() {
  const [month, setMonth] = useState(today().slice(0, 7));
  const [d, setD] = useState(null);
  useEffect(() => {
    let live = true;
    if (month) api.get("/reports/per-km", { params: { month } }).then((r) => { if (live) setD(r.data); }).catch((e) => toast.error(errMsg(e)));
    return () => { live = false; };
  }, [month]);
  return (
    <div className="space-y-5" data-testid="perkm-report-page">
      <PageHeader title="Per-KM Trip Report" subtitle="Per-KM gaadiyon ka mahina-war km, allowance, driver khate se kata diesel aur driver balance" />
      <Field label="Month" className="max-w-xs"><Input type="month" data-testid="perkm-month" value={month} onChange={(e) => setMonth(e.target.value)} /></Field>
      {d && <>
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
          <StatCard testid="perkm-km" label="KM Run" value={Number(d.totals.km).toLocaleString("en-IN")} />
          <StatCard testid="perkm-allowance" label="Per-KM Allowance" value={inr(d.totals.allowance, 2)} />
          <StatCard testid="perkm-diesel" label="Diesel Debited to Drivers" value={inr(d.totals.diesel, 2)} accent="text-rose-600" />
          <StatCard testid="perkm-net" label="Net Driver Payout" value={inr(d.totals.net, 2)} />
          <StatCard testid="perkm-total-balance" label="Driver Balance (open)" value={inr(d.totals.balance, 2)} accent={d.totals.balance < 0 ? "text-rose-600" : "text-emerald-600"} />
        </div>
        {d.rows.length ? d.rows.map((r) => <VehicleBlock key={r.vehicle_id} r={r} />)
          : <Empty testid="perkm-empty" text={d.per_km_vehicles ? "Is mahine Per-KM gaadiyon ki koi trip nahi" : "Fleet me abhi koi gaadi \"Fixed Per-KM Rate\" par nahi hai"} />}
        <p className="text-xs text-muted-foreground">Balance: "Pay" = driver ko dena baaki, "Recover" = driver se lena baaki. Settled trips ka balance nahi gina jaata.</p>
      </>}
    </div>
  );
}
